import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { content } from './shared/routes/content-routes';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { LoginComponent } from './components/auth/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { MustChangePasswordGuard } from './guards/must-chang-password.guard';
import { CambioContrasenaComponent } from './shared/components/cambio-contrasena/cambio-contrasena.component';
import { RecoverPasswordComponent } from './shared/components/recover-password/recover-password.component';
import { VisorWrapperComponent } from './components/visor/visor-wrapper/visor-wrapper.component';
import { ValidateTokenComponent } from './components/users/validate-token/validate-token.component';
import { ResetMFAComponent } from './shared/components/reset-mfa/reset-mfa.component';
import { FormMFAComponent } from './shared/components/form-mfa/form-mfa.component';
import { PartialTokenGuard } from './guards/partial-token.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/default',
    pathMatch: 'full'
  },
  {
    path: 'not-authorized' , 
    component:  NotAuthorizedComponent , 
    pathMatch: 'full'
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: content , 
    canActivate:[  AuthGuard , MustChangePasswordGuard ] , 
    canActivateChild: [ AuthGuard ]
  },
  {
    path: 'force-change-password',
    component: CambioContrasenaComponent,    
    canActivate:[  AuthGuard ] , 
    canActivateChild: [ AuthGuard ]
  },
  {
    path: 'force-reset-mfa' , 
    component: ResetMFAComponent  ,
    canActivate:[  PartialTokenGuard ] 
  },
  {
    path: 'mfa' , 
    component: FormMFAComponent  ,
    canActivate:[  PartialTokenGuard ]     
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent    
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  } , 
  {
    path: 'visor/:id',
    component: VisorWrapperComponent,
    canActivate:[  AuthGuard ] , 
    canActivateChild: [ AuthGuard ]
  } ,
  {
    path: 'visor',
    component: VisorWrapperComponent,
    canActivate:[  AuthGuard ] , 
    canActivateChild: [ AuthGuard ]
  } ,
  {
    path: 'validate-token/:token/:id',
    component: ValidateTokenComponent,
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
